'use client';

import { HeaderBottom } from '@eliadmin/core/src/components/header/header-bottom';
import type { HeaderClientProps } from '@eliadmin/core/src/components/header/header-client';
import { HeaderMain } from '@eliadmin/core/src/components/header/header-main';
import { Topbar } from '@eliadmin/core/src/components/header/topbar';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useEffect, useState } from 'react';

export function DefaultHeader({ categories, menu, generalLayout }: HeaderClientProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Topbar generalLayout={generalLayout} />
      <header
        className={cn('sticky left-0 top-0 z-40 flex w-full flex-col bg-white transition-all')}
        style={{
          boxShadow: scrolled ? '0px 16px 32px 0px #0000001F' : '0px 16px 32px 0px #00000000',
          transition: 'box-shadow 0.4s ease',
        }}
      >
        <HeaderMain generalLayout={generalLayout} categories={categories} menu={menu} />
        <HeaderBottom generalLayout={generalLayout} categories={categories} menu={menu} />
      </header>
    </>
  );
}
